export const getBvnRecordAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_RECORD_DETAILS":
      return action.data;

    default:
      return state;
  }
};
